import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "120px",
	height: "20px",
	viewBox: "0 0 160 26",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Logo / Catalyst" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsxs("g", {
			id: "Logo-/-Catalyst",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ _jsxs("g", {
				id: "Logo-Catalyst",
				children: [/* @__PURE__ */ _jsxs("g", {
					id: "Logo-/-CATALYST_LOGO_onDARK",
					transform: "translate(36.000000, 0.000000)",
					children: [/* @__PURE__ */ _jsx("g", {
						id: "CATALYST_LOGO_onDARK",
						strokeWidth: 1,
						fillRule: "evenodd",
						children: /* @__PURE__ */ _jsxs("g", {
							id: "CATALYST_onDARK",
							fillRule: "nonzero",
							children: [
								/* @__PURE__ */ _jsx("path", {
									d: "M18.5299215,17.8813604 C16.2681464,21.5732923 11.7823048,23.3358922 7.5529218,22.1944991 C3.32353881,21.0531061 0.383672786,17.286514 0.358974494,12.9775264 C0.482370739,8.73234972 3.42379772,5.06860297 7.59720967,3.96181371 C11.7706216,2.85502445 16.1890731,4.56693071 18.4700924,8.17445614 L16.0769291,8.17445614 C13.7775015,5.44285265 9.86386333,4.63093074 6.63661782,6.2159727 C3.40937233,7.80101466 1.72186612,11.3639045 2.56608725,14.8102238 C3.41030838,18.256543 6.56302834,20.6750177 10.170944,20.6439654 C12.4895915,20.6670956 14.692367,19.6499651 16.1538522,17.8813604 L18.5299215,17.8813604 Z",
									id: "Path",
									fill: "#FFFFFF"
								}),
								/* @__PURE__ */ _jsx("path", {
									d: "M28.0171046,3.83321954 L30.0940284,3.83321954 L38.529929,22.3065667 L36.4615522,22.3065667 L33.0940296,14.9676097 L25.0256504,14.9676097 L21.6581278,22.2729788 L19.581204,22.2729788 L28.0171046,3.83321954 Z M29.05984,6.10880003 L25.8290695,13.1370689 L32.2735164,13.1370689 L29.05984,6.10880003 Z",
									id: "Shape",
									fill: "#FFFFFF"
								}),
								/* @__PURE__ */ _jsx("polygon", {
									id: "Path",
									fill: "#FFFFFF",
									points: "42.5299305 5.63856937 36.1709537 5.63856937 36.1709537 3.83321954 50.7863439 3.83321954 50.7863439 5.63856937 44.4444612 5.63856937 44.4444612 22.2729788 42.5299305 22.2729788"
								}),
								/* @__PURE__ */ _jsx("path", {
									d: "M58.179509,3.83321954 L60.2564329,3.83321954 L68.6923335,22.3065667 L66.6154097,22.3065667 L63.247887,14.9424187 L55.1795079,14.9424187 L51.8119853,22.2729788 L49.7350614,22.2729788 L58.179509,3.83321954 Z M59.2307915,6.10880003 L56.000021,13.1370689 L62.4444679,13.1370689 L59.2307915,6.10880003 Z",
									id: "Shape",
									fill: "#FFFFFF"
								}),
								/* @__PURE__ */ _jsx("polygon", {
									id: "Path",
									fill: "#FFFFFF",
									points: "70.2735307 3.83321954 72.1966084 3.83321954 72.1966084 20.467629 80.8461843 20.467629 80.8461843 22.2729788 70.2735307 22.2729788"
								}),
								/* @__PURE__ */ _jsx("polygon", {
									id: "Path",
									fill: "#589DD5",
									points: "88.2222558 16.8989142 81.7265264 3.85001349 83.8034503 3.85001349 89.2735381 14.8248611 94.743625 3.85001349 96.8205488 3.85001349 87.6154172 22.3233607 85.5384934 22.3233607"
								}),
								/* @__PURE__ */ _jsx("path", {
									d: "M105.700894,7.60346175 C105.24518,6.31442783 104.012889,5.44678933 102.62397,5.43704195 C101.754491,5.37720097 100.897844,5.66876999 100.252394,6.24423373 C99.6069437,6.81969748 99.2286705,7.62914585 99.2051656,8.48514427 C99.2051656,10.0889666 100.333371,10.8111066 102.62397,11.5080556 C106.119698,12.5912655 108.726536,13.9347816 108.726536,17.1676174 C108.726536,20.4004531 106.017134,22.5164911 102.62397,22.5164911 C99.6201167,22.6246197 97.0154826,20.4927961 96.5812326,17.5706722 L98.5812326,17.5706722 C99.0110066,19.4109149 100.71212,20.6907977 102.632517,20.6187745 C104.923117,20.6187745 106.735083,19.3004493 106.735083,17.1592204 C106.735083,15.4798252 105.606877,14.5225699 102.632517,13.6240935 C99.1367897,12.5660746 97.2393526,11.2729403 97.2393526,8.48514427 C97.2393526,5.6973482 99.3931995,3.55611933 102.632517,3.55611933 C105.1353,3.48450555 107.324818,5.19898269 107.812007,7.61185873 L105.700894,7.60346175 Z",
									id: "Path",
									fill: "#FFFFFF"
								}),
								/* @__PURE__ */ _jsx("polygon", {
									id: "Path",
									fill: "#FFFFFF",
									points: "115.880386 5.63856937 109.521409 5.63856937 109.521409 3.83321954 124.136799 3.83321954 124.136799 5.63856937 117.803463 5.63856937 117.803463 22.2729788 115.880386 22.2729788"
								}),
								/* @__PURE__ */ _jsx("rect", {
									id: "Rectangle",
									fill: "#589DD5",
									x: 109.427392,
									y: .0965652242,
									width: 14.7863304,
									height: 1.9564954
								})
							]
						})
					}), /* @__PURE__ */ _jsx("rect", {
						id: "Rectangle-Copy",
						x: 0,
						y: 0,
						width: 125,
						height: 24
					})]
				}), /* @__PURE__ */ _jsxs("g", {
					id: "Logo-/-icon",
					transform: "translate(0.000000, 1.000000)",
					children: [/* @__PURE__ */ _jsx("g", {
						id: "by_IntellectEU_onDARK-2",
						strokeWidth: 1,
						fillRule: "evenodd",
						children: /* @__PURE__ */ _jsxs("g", {
							id: "by_IntellectEU_onDARK",
							fillRule: "nonzero",
							children: [
								/* @__PURE__ */ _jsx("path", {
									d: "M0.608547009,20.0270769 L2.55726496,20.4996923 C2.90803419,20.4996923 3.20034188,20.1783139 3.20034188,19.5733661 L3.20034188,16.1138216 C3.20034188,15.5277784 2.92752137,14.9984493 2.55726496,14.96064 L0.608547009,14.7715939 C0.296752137,14.7715939 0.0434188034,15.1685907 0.0434188034,15.69792 L0.0434188034,18.7793723 C0.101880342,19.3654154 0.335726496,19.87584 0.608547009,20.0270769 Z",
									id: "Path",
									fill: "#589DD5"
								}),
								/* @__PURE__ */ _jsx("path", {
									d: "M4.5059829,20.8777846 L6.8834188,21.4638277 C7.33162393,21.5772554 7.72136752,21.1235446 7.72136752,20.4618831 L7.72136752,16.68096 C7.72136752,16.0192984 7.31213675,15.4332554 6.8834188,15.3954461 L4.5059829,15.1496861 C4.11623932,15.1496861 3.80444445,15.5844923 3.80444445,16.18944 L3.80444445,19.6111754 C3.76547009,20.2161231 4.05777778,20.7832616 4.5059829,20.8777846 Z",
									id: "Path",
									fill: "#589DD5"
								}),
								/* @__PURE__ */ _jsx("path", {
									d: "M9.1439316,22.0498707 L12.1644445,22.7871507 C12.7295726,22.9383877 13.2362393,22.4279631 13.2362393,21.6717784 L13.2362393,17.3804307 C13.2911695,16.7087923 12.8512932,16.0924099 12.1839316,15.9058707 L9.1634188,15.6223016 C8.67623928,15.6223016 8.26700856,16.0949169 8.26700856,16.7754831 L8.26700856,20.5564061 C8.20515192,21.1838698 8.5560376,21.7814539 9.1439316,22.0498707 L9.1439316,22.0498707 Z",
									id: "Path",
									fill: "#589DD5"
								}),
								/* @__PURE__ */ _jsx("path", {
									d: "M0.608547009,14.0721231 L2.55726496,14.22336 C2.90803419,14.22336 3.20034188,13.7885539 3.20034188,13.1836061 L3.20034188,9.79968 C3.20034188,9.21363694 2.92752137,8.74102157 2.55726496,8.75992612 L0.608547009,8.91116306 C0.296752137,8.91116306 0.0434188034,9.40268306 0.0434188034,9.95091694 L0.0434188034,13.0323693 C0.101880342,13.5806031 0.335726496,14.0532184 0.608547009,14.0721231 Z",
									id: "Path",
									fill: "#589DD5"
								}),
								/* @__PURE__ */ _jsx("path", {
									d: "M4.5059829,14.3556923 L6.8834188,14.5258339 C7.33162393,14.5258339 7.72136752,14.0343139 7.72136752,13.3726523 L7.72136752,9.59172925 C7.72136752,8.93006769 7.31213675,8.40073843 6.8834188,8.43854769 L4.5059829,8.68430769 C4.11623932,8.68430769 3.80444445,9.23254157 3.80444445,9.83748925 L3.80444445,13.2592246 C3.76547009,13.8074584 4.05777778,14.3556923 4.5059829,14.3556923 Z",
									id: "Path",
									fill: "#FFFFFF"
								}),
								/* @__PURE__ */ _jsx("path", {
									d: "M9.1439316,14.71488 L12.1644445,14.9417354 C12.7295726,14.9417354 13.2362393,14.3935016 13.2362393,13.6373169 L13.2362393,9.34596925 C13.2362393,8.58978463 12.7490598,8.00374157 12.1839316,8.04155075 L9.1634188,8.26840612 C8.67623928,8.26840612 8.26700856,8.89225843 8.26700856,9.57282463 L8.26700856,13.3537477 C8.26700856,14.0910277 8.65675216,14.6770707 9.1439316,14.71488 Z",
									id: "Path",
									fill: "#589DD5"
								}),
								/* @__PURE__ */ _jsx("path", {
									d: "M0.608547009,8.19278769 L2.55726496,8.00374157 C2.90803419,8.00374157 3.20034188,7.45550769 3.20034188,6.85056 L3.20034188,3.48553846 C3.20034188,2.89949539 2.92752137,2.48359384 2.55726496,2.55921231 L0.608547009,3.01292307 C0.296752137,3.01292307 0.0434188034,3.59896616 0.0434188034,4.1472 L0.0434188034,7.22865231 C0.101880342,7.81469537 0.335726496,8.23059694 0.608547009,8.19278769 Z",
									id: "Path",
									fill: "#589DD5"
								}),
								/* @__PURE__ */ _jsx("path", {
									d: "M4.5059829,7.8336 L6.8834188,7.60674461 C7.33162393,7.60674461 7.72136752,6.98289231 7.72136752,6.32123077 L7.72136752,2.54030769 C7.72136752,1.87864616 7.31213675,1.42493539 6.8834188,1.53836307 L4.5059829,2.10550154 C4.11623932,2.20002461 3.80444445,2.76716307 3.80444445,3.37211077 L3.80444445,6.79384616 C3.76547009,7.39879384 4.05777778,7.87140925 4.5059829,7.8336 Z",
									id: "Path",
									fill: "#589DD5"
								}),
								/* @__PURE__ */ _jsx("path", {
									d: "M9.1439316,7.37988923 L12.1644445,7.09632 C12.8395875,6.91718348 13.2890341,6.29884134 13.2362393,5.62176 L13.2362393,1.31150769 C13.2362393,0.555323077 12.7490598,0.0448984616 12.1839316,0.196135384 L9.1634188,0.933415388 C8.58211784,1.19108753 8.22538008,1.77038399 8.26700856,2.38907077 L8.26700856,6.16999384 C8.26700856,6.90727384 8.65675216,7.41769846 9.1439316,7.37988923 Z",
									id: "Path",
									fill: "#589DD5"
								}),
								/* @__PURE__ */ _jsx("path", {
									d: "M26.2147009,15.4899693 C26.4291907,15.4573485 26.6482526,15.5087382 26.823679,15.6328292 C26.9991052,15.7569201 27.1165203,15.9435438 27.1500854,16.1516307 L27.1500854,15.7168246 C27.1500854,15.1685907 26.9162393,14.7526893 26.5849573,14.7904984 L24.6362393,14.9795446 C24.2854701,14.9795446 23.9931624,15.5277784 23.9931624,16.1327261 L23.9931624,16.1327261 L25.4936752,15.9247754 C25.6316854,15.6607917 25.9096036,15.4931963 26.2147009,15.4899693 Z",
									id: "Path",
									fill: "#FFFFFF"
								}),
								/* @__PURE__ */ _jsx("path", {
									d: "M26.448547,17.0779569 C26.1712711,17.1186286 25.8918342,17.0187559 25.7080342,16.8132923 L24.0711111,17.0401477 L24.0711111,19.4977477 C24.0711111,20.0837907 24.3439316,20.4996923 24.714188,20.4240739 L26.662906,19.9514584 C26.9747009,19.9514584 27.2280342,19.3654154 27.2280342,18.8171816 L27.2280342,16.4162954 C27.163396,16.7885752 26.8374832,17.0652237 26.448547,17.0779569 L26.448547,17.0779569 Z",
									id: "Path",
									fill: "#FFFFFF"
								}),
								/* @__PURE__ */ _jsx("path", {
									d: "M23.4670086,16.2461539 L23.4670086,16.2461539 C23.4670086,15.6412061 23.1552137,15.1874954 22.7654701,15.2064 L20.4075214,15.4332554 C19.9593162,15.4332554 19.5695726,16.0571077 19.5695726,16.7187693 L19.5695726,19.1196554 L23.3111111,16.2461539 L23.4670086,16.2461539 Z",
									id: "Path",
									fill: "#FFFFFF"
								}),
								/* @__PURE__ */ _jsx("path", {
									d: "M19.5695726,20.0270769 L19.5695726,20.4618831 C19.5695726,21.1235446 19.9593162,21.5772554 20.4075214,21.4638277 L22.7849573,20.8777846 C23.1747009,20.7832616 23.4670086,20.2161231 23.4670086,19.6111754 L23.4670086,17.2480984 L19.8034188,20.0270769 L19.5695726,20.0270769 Z",
									id: "Path",
									fill: "#FFFFFF"
								}),
								/* @__PURE__ */ _jsx("path", {
									d: "M14.9900854,21.3125907 C14.7754163,21.3571241 14.5513046,21.3161335 14.368089,21.1988261 C14.1848734,21.0815188 14.0579136,20.897729 14.0157265,20.6887384 L14.0157265,21.6906831 C14.0157265,22.4468677 14.502906,22.9572923 15.0875214,22.8060554 L18.1080342,22.0687754 C18.6893351,21.8111032 19.0460729,21.2318067 19.0044445,20.61312 L19.0044445,20.1405046 L15.6331624,20.8021661 C15.5303835,21.0730607 15.2841506,21.2685013 14.9900854,21.3125907 L14.9900854,21.3125907 Z",
									id: "Path",
									fill: "#FFFFFF"
								}),
								/* @__PURE__ */ _jsx("path", {
									d: "M14.6588034,19.7246031 C14.9355253,19.6677383 15.2228993,19.7535176 15.4188034,19.9514584 L18.9654701,19.2519877 L18.9654701,16.7565784 C18.9654701,16.0760123 18.5562393,15.5655877 18.0690598,15.6033969 L15.048547,15.8869661 C14.3811854,16.0735053 13.9413091,16.6898877 13.9962393,17.3615261 L13.9962393,20.4240739 C14.0331073,20.0743284 14.3026753,19.7897447 14.6588034,19.7246031 L14.6588034,19.7246031 Z",
									id: "Path",
									fill: "#FFFFFF"
								}),
								/* @__PURE__ */ _jsx("path", {
									d: "M26.3121367,10.6881969 C26.5326252,10.6881363 26.7438126,10.7743791 26.8978766,10.9273958 C27.0519406,11.0804127 27.135848,11.287259 27.1305983,11.5010954 C27.1200104,11.9426471 26.7479313,12.2952087 26.2926496,12.2950893 C26.0067865,12.2965587 25.740847,12.1532314 25.5911111,11.9169969 L23.9931624,11.9169969 L23.9931624,13.1836061 C23.9931624,13.7696493 24.2659829,14.2422646 24.6362393,14.22336 L26.5849573,14.0721231 C26.8967522,14.0721231 27.1500854,13.5806031 27.1500854,13.0323693 L27.1500854,9.95091694 C27.1500854,9.40268306 26.9162393,8.94897231 26.5849573,8.91116306 L24.6362393,8.75992612 C24.2854701,8.75992612 23.9931624,9.19473231 23.9931624,9.79968 L23.9931624,11.0662893 L25.5326496,11.0662893 C25.6991696,10.8087856 25.9998737,10.6629284 26.3121367,10.6881969 L26.3121367,10.6881969 Z",
									id: "Path",
									fill: "#FFFFFF"
								}),
								/* @__PURE__ */ _jsx("path", {
									d: "M23.4670086,9.78077537 C23.4670086,9.17582769 23.1552137,8.66540306 22.7654701,8.62759388 L20.4075214,8.45745231 C19.9593162,8.45745231 19.5695726,8.94897231 19.5695726,9.61063388 L19.5695726,11.0851939 L23.4670086,11.0851939 L23.4670086,9.78077537 Z",
									id: "Path",
									fill: "#FFFFFF"
								}),
								/* @__PURE__ */ _jsx("path", {
									d: "M19.5695726,13.3915569 C19.5695726,14.0532184 19.9593162,14.5825477 20.4075214,14.5447384 L22.7849573,14.3745969 C23.1747009,14.3745969 23.4670086,13.8263631 23.4670086,13.2214154 L23.4670086,11.9359016 L19.5695726,11.9359016 L19.5695726,13.3915569 Z",
									id: "Path",
									fill: "#FFFFFF"
								}),
								/* @__PURE__ */ _jsx("path", {
									d: "M14.8147009,10.6881969 C15.0995979,10.6903349 15.3638565,10.8327563 15.5162393,11.0662893 L18.9654701,11.0662893 L18.9654701,9.57282463 C18.9654701,8.89225843 18.5562393,8.30621537 18.0690598,8.26840612 L15.048547,8.04155075 C14.4834188,8.04155075 13.9962393,8.58978463 13.9962393,9.34596925 L13.9962393,11.3687631 C14.054798,10.9750375 14.404661,10.6841198 14.8147009,10.6881969 L14.8147009,10.6881969 Z",
									id: "Path",
									fill: "#FFFFFF"
								}),
								/* @__PURE__ */ _jsx("path", {
									d: "M14.834188,12.2950893 C14.4271963,12.2911706 14.0819642,12.0041035 14.0157265,11.6145231 L14.0157265,13.6562216 C14.0157265,14.4124061 14.502906,14.9984493 15.0875214,14.96064 L18.1080342,14.7337846 C18.5952137,14.7337846 19.0044445,14.1099323 19.0044445,13.4293661 L19.0044445,11.9359016 L15.5552137,11.9359016 C15.3971468,12.1707799 15.1230591,12.30732 14.834188,12.2950893 L14.834188,12.2950893 Z",
									id: "Path",
									fill: "#FFFFFF"
								}),
								/* @__PURE__ */ _jsx("path", {
									d: "M26.448547,5.81080616 C26.8046293,5.86226289 27.0870356,6.12861662 27.1500854,6.47246769 L27.1500854,4.16610461 C27.1500854,3.61787077 26.9162393,3.10744616 26.5849573,3.03182769 L24.6362393,2.55921231 C24.2854701,2.55921231 23.9931624,2.88059077 23.9931624,3.48553846 L23.9931624,5.86752 L25.6300854,6.09437539 C25.8243682,5.85553471 26.1422553,5.74539759 26.448547,5.81080616 L26.448547,5.81080616 Z",
									id: "Path",
									fill: "#FFFFFF"
								}),
								/* @__PURE__ */ _jsx("path", {
									d: "M26.2147009,7.39879384 C25.9296339,7.36180762 25.6854973,7.1823847 25.5716239,6.92617846 L23.9931624,6.79384616 L23.9931624,6.79384616 C23.9931624,7.37988923 24.2659829,7.90921843 24.6362393,7.94702769 L26.5849573,8.13607388 C26.8967522,8.13607388 27.1500854,7.73907694 27.1500854,7.20974769 L27.1500854,6.79384616 C27.0529379,7.20418768 26.6425145,7.46962365 26.2147009,7.39879384 L26.2147009,7.39879384 Z",
									id: "Path",
									fill: "#FFFFFF"
								}),
								/* @__PURE__ */ _jsx("path", {
									d: "M19.5695726,3.88253539 L19.5695726,6.30232616 C19.5695726,6.96398769 19.9593162,7.55003077 20.4075214,7.58784 L22.7849573,7.81469537 C23.1747009,7.81469537 23.4670086,7.37988923 23.4670086,6.79384616 L23.4670086,6.64260923 L23.2916239,6.64260923 L19.5695726,3.88253539 Z",
									id: "Path",
									fill: "#FFFFFF"
								}),
								/* @__PURE__ */ _jsx("path", {
									d: "M23.4670086,5.67847384 L23.4670086,3.37211077 C23.4670086,2.76716307 23.1552137,2.20002461 22.7654701,2.10550154 L20.4075214,1.51945846 C19.9593162,1.40603077 19.5695726,1.85974154 19.5695726,2.52140307 L19.5695726,3.01292307 L19.7839316,3.01292307 L23.4670086,5.67847384 Z",
									id: "Path",
									fill: "#FFFFFF"
								}),
								/* @__PURE__ */ _jsx("path", {
									d: "M14.9900854,1.67069539 C15.264892,1.72344652 15.4927982,1.90887936 15.594188,2.16221539 L18.9654701,2.80497231 L18.9654701,2.37016616 C19.0070986,1.75147938 18.6503608,1.17218292 18.0690598,0.914510769 L15.048547,0.177230769 C14.4834188,0.0259938461 13.9962393,0.536418461 13.9962393,1.29260307 L13.9962393,2.40797539 C14.0087655,2.1783602 14.1232846,1.96528882 14.3101772,1.82387056 C14.4970698,1.68245229 14.73798,1.62657663 14.9705983,1.67069539 L14.9900854,1.67069539 Z",
									id: "Path",
									fill: "#FFFFFF"
								}),
								/* @__PURE__ */ _jsx("path", {
									d: "M14.6782906,3.25868307 C14.309089,3.18972882 14.0358025,2.88562432 14.0157265,2.52140307 L14.0157265,5.60285539 C13.9629318,6.27993672 14.4123783,6.89827887 15.0875214,7.07741539 L18.1080342,7.36098461 C18.5952137,7.36098461 19.0044445,6.88836923 19.0044445,6.20780307 L19.0044445,3.69348923 L15.4382906,3.01292307 C15.2464222,3.21773931 14.9584621,3.31085649 14.6782906,3.25868307 L14.6782906,3.25868307 Z",
									id: "Path",
									fill: "#FFFFFF"
								})
							]
						})
					}), /* @__PURE__ */ _jsx("rect", {
						id: "Rectangle",
						x: 0,
						y: 0,
						width: 28,
						height: 24
					})]
				})]
			}), /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle-Copy-2",
				x: 0,
				y: 0,
				width: 161,
				height: 26
			})]
		})
	]
});
export default SvgLogo;
